import { render, staticRenderFns } from "./FormalSector.vue?vue&type=template&id=58bef990&"
import script from "./FormalSector.vue?vue&type=script&lang=js&"
export * from "./FormalSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports